import { DataGridPro } from '@mui/x-data-grid-pro'
import { Box } from '@mui/material'
import PageSection from '../../../Constants&Theme/PageSection'
import { useGetLimsOrders } from '../../../APIs/Hooks/LimsHooks'
import { useEffect, useState } from 'react'
import OrdersAsyncToolbar from './OrdersAsyncToolbar'
import { addMonths } from 'date-fns'
import { getCodeSetLabelFromList, getCodeSetLabelLookup, getLabelFromList } from '../../../Functions/CodeSetFns'
import { useBioBankContext } from '../../../Contexts/Modules/BioBankModule'
import { useNavigate } from 'react-router-dom'
import { formatValueDate } from '../../../Functions/FormatValues'
import { useUserContext } from '../../../Contexts/UserConfig'

export interface tsGetLimsOrdersFilters {
  owner_id?: number | string
  status?: string | undefined
  start_range: Date | null
  end_range: Date | null
  enabled: boolean
}

function OrdersList() {
  const navigate = useNavigate()
  const { loginConfig } = useUserContext()
  const { ownersQuery, statusQuery } = useBioBankContext()
  const [apiFilters, setApiFilters] = useState<tsGetLimsOrdersFilters>({
    enabled: false,
    start_range: addMonths(new Date(), -1),
    end_range: addMonths(new Date(), 5),
  })

  useEffect(() => {
    if (ownersQuery.data && ownersQuery.data.length === 1)
      setApiFilters((f) => {
        return {
          ...f,
          owner_id: ownersQuery.data[0].OwnerID,
          enabled: true,
        }
      })
  }, [ownersQuery.data])
  const issuesQuery = useGetLimsOrders(apiFilters)
  return (
    <Box sx={{ maxWidth: 'lg', width: 1 }}>
      <PageSection title={'Orders'}>
        <OrdersAsyncToolbar
          apiFilters={apiFilters}
          setApiFilters={setApiFilters}
        />
        <DataGridPro
          getRowId={(row) => row.LIMSOrderId}
          sx={{ width: 1 }}
          autoHeight
          disableRowSelectionOnClick
          disableColumnMenu
          loading={issuesQuery.isLoading}
          onRowClick={({ row }) => navigate(row.LIMSOrderId.toString())}
          columns={[
            {
              field: 'LIMSOrderId',
              headerName: 'LIMS Order Id',
              flex: 0.5,
            },
            {
              field: 'IssueStatus',
              headerName: 'Issue Status',
              flex: 1,
              valueFormatter: (value: any) =>
                getCodeSetLabelFromList(statusQuery.data ?? [], value),
            },
            {
              field: 'IssueDate',
              headerName: 'Issue Date',
              flex: 1,
              valueFormatter: (value: any) => formatValueDate(value),
            },
            {
              field: 'ToOwner',
              headerName: 'To Owner',
              flex: 1.5,
              valueFormatter: (value: any) =>
                getLabelFromList(
                  ownersQuery.data ?? [],
                  value,
                  'OwnerID',
                  'OwnerName',
                ),
            },
            {
              field: 'ToFacility',
              headerName: 'To Facility',
              flex: 1,
              valueFormatter: (value: any) =>
                getCodeSetLabelLookup(loginConfig, ['KV-Facilities'], value),
            },
          ]}
          rows={issuesQuery.data ?? []}
        />
      </PageSection>
    </Box>
  )
}

export default OrdersList
